import {
  Form,
  Input,
  Drawer,
  Modal,
  Button,
  message,
} from "antd/lib/";
import React, { useEffect, useState } from "react";
import { Retailer, RetailerDetailFormData } from "./types";
import { useForm } from "antd/lib/form/Form";
import { updateParams } from "./types";
import { retailerService } from "../../services/RetailerService";

interface IRetailerProps {
  values: RetailerDetailFormData;
  isChanged: boolean;
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isCreate: boolean;
  onSubmit?: (data: RetailerDetailFormData) => void;
  onClose: () => void;
}

const RetailersForm: React.FC<IRetailerProps> = (props) => {
  const [state, setState] = useState({
    loading: false,
    visible: false,
  });
  const [changed, setChanged] = useState(false);
  var ObjectID = require("bson-objectid");
  const [form] = useForm();
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 5,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 19,
      },
    },
  };

  const handleOk = () => {
    setState({
      ...state,
      loading: false,
    });
  };

  const handleCancel = () => {
    setState({ ...state, visible: false });
    setChanged(false);
    form.resetFields(["_id", "name"]);
    props.setVisible(false);
  };

  function warning() {
    Modal.warning({
      cancelText: "Discard Changes",
      okText: "Keep Editing",
      onOk: handleOk,
      onCancel: handleCancel,
      centered: true,
      title: "Warning",
      content: "Do you really want to discard your changes!",
      okCancel: true,
    });
  }

  const onClose = () => {
    props.onClose();
    if (changed) warning();
    else {
      form.resetFields(["_id", "name"]);
      props.setVisible(false);
    }
  };

  async function validateProduct() {
    try {
      await form.validateFields();
      return true;
    } catch {
      return false;
    }
  }

  const onSubmit = async () => {
    try {
      const formValues = (await form.getFieldsValue()) as Retailer;

      let retailers;

      if (props.isCreate === true) {
        const _id = ObjectID();
        retailers = updateParams({
          ...formValues,
          _id: _id,
        });
      } else
        retailers = updateParams({
          ...formValues,
          _id: props.values._id,
        });
      try {
        setState({ ...state, loading: true });
        let res;
        if (props.isCreate === false)
          res = await retailerService.updateRetailer(retailers);
        else res = await retailerService.addRetailer(retailers);

        if (res.status !== 200) {
          throw new Error("Failed to fetch!");
        } else {
          message.success("Data saved.");
          setChanged(false);
        }
        if (changed === true) {
          form.resetFields([
            "parent_brand",
            "manufacturer",
            "category",
            "categories",
          ]);
          props.onClose();
          props.setVisible(false);
        }
      } catch (err: any) {
        const error = err.toString();
        message.error(error);
      } finally {
        setState({ ...state, loading: false });
      }
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  async function submitWarning() {
    if ((await validateProduct()) === true) {
      Modal.confirm({
        cancelText: "Cancel",
        okText: "Submit",
        onOk: onSubmit,
        centered: true,
        title: "Confirm Dialog",
        content: "Do you really want to save your changes",
        okCancel: true,
      });
    } else {
      message.error("Please fill all '*' fields.");
      form.validateFields();
    }
  }

  useEffect(() => {
    form.setFieldsValue(props.values);
  }, [props.values]);

  return (
    <>
      <Drawer
        title="Details"
        placement="right"
        width={"80%"}
        closable={false}
        onClose={onClose}
        visible={props.visible}
        getContainer={false}
        style={{
          display: props.visible ? "block" : "none",
          position: "fixed",
        }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button onClick={submitWarning} type="primary">
              Submit
            </Button>
          </div>
        }
      >
        {props.visible && (
          <Form
            initialValues={props.values}
            form={form}
            style={{ fontWeight: "bold" }}
            onChange={() => {
              setChanged(true);
            }}
            {...formItemLayout}
          >
            <Form.Item label="ID : " style={{ display: "none" }} name={"_id"}>
              <Input value={props.values._id} disabled />
            </Form.Item>
            <Form.Item
              label="Name"
              rules={[{ required: true, message: ""}]}
              name="name"
            >
              <Input />
            </Form.Item>
          </Form>
        )}
      </Drawer>
    </>
  );
};
export default RetailersForm;
